export default {
    s: {
        width: 360,
        height: 640,
    },
    m: {
        width: 768,
        height: 1024,
    },
    l: {
        width: 1024,
        height: 768,
    },
    xl: {
        width: 1400,
        height: 900,
    },
};
